import React from "react";
import PrivacyPolicyComponent from "./components/PrivacyPolicy";

const PrivacyPolicy = () => {
  return (
    <>
      <PrivacyPolicyComponent />
    </>
  );
};

export default PrivacyPolicy;
